import { FunctionComponent, memo } from 'react';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

type CustomRenderProps = FunctionComponent<{ option: TReactSelectOption; idx: number }>;

const RenderFocusedLabelContent: CustomRenderProps = memo(({ option }) => {
  return <div data-component="RenderFocusedLabelContent">{option.label}</div>;
});

RenderFocusedLabelContent.displayName = 'RenderFocusedLabelContent';

export default RenderFocusedLabelContent;
